import { Tooltip as AntdTooltip } from "antd";
import React from "react";

export type MyTooltipProps = React.ComponentProps<typeof AntdTooltip>;

const Tooltip: React.FC<MyTooltipProps> = (props) => {
  return <AntdTooltip {...props} />;
};

export default Tooltip;
